import { register } from '@shopify/theme-sections';
import * as cart from '@shopify/theme-cart';
import ProductVariants from '../components/ProductVariants';
import ProductKit from '../components/ProductKit';
import Swiper from 'swiper/bundle';
import { buildSizes, waitForElm, buildTable } from '../helpers/util';

register('main-kit-product', {
  buildVideo(media) {
    let videoHtml = '',
      iframeClass = '',
      playerHtml;
    if (media.media_type == 'video') {
      playerHtml = `<video playsinline="playsinline" autoplay="autoplay" loop="loop" muted="muted" preload="none"><source src="${media.sources[0].url}" type="video/mp4"></video>`;
    } else {
      if (media.host == 'vimeo') {
        iframeClass = '-frame js-vimeo-frame';
        playerHtml = `<iframe frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen" class="js-vimeo" loading="lazy" src="https://player.vimeo.com/video/${media.external_id}?autopause=0&autoplay=1&amp;background=1&amp;byline=0&amp;controls=0&amp;loop=1&amp;muted=1&amp;playsinline=1&amp;sidedock=0&amp;title=0"></iframe>`;
      } else {
        return videoHtml;
      }
    }
    videoHtml = `<div class="${this.type}__image--item">
      <div class="${this.type}__image--video${iframeClass}">${playerHtml}</div>
      <div class="${this.type}__image--pause-play pause">
        <a href="#" class="pause-video switch-play-pause">
          <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="17.5" r="16.5" fill="white" stroke="black" stroke-width="2"/>
            <path d="M22.2241 10.8621L22.2241 24.1379" stroke="black" stroke-width="2"/>
            <path d="M14.9827 10.8621L14.9827 24.1379" stroke="black" stroke-width="2"/>
          </svg>
        </a>
        <a href="#" class="play-video switch-play-pause">
          <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="14.5" cy="14.5" r="13.5" fill="white" stroke="black" stroke-width="2"/>
            <path d="M20.875 14.5L12.125 8.25L12.125 20.75L20.875 14.5Z" fill="black"/>
          </svg>
        </a>
      </div>
    </div>`;
    return videoHtml;
  },

  setBenefits() {
    let benefitsContainer = this.mainProductItem.el.querySelector(
      '[data-product-benefits-container]',
    );
    if (!benefitsContainer) return;
    let benefitsItems = this.mainProductItem.buildBenefits(
      this.mainProductItem.benefitTags,
      this.type,
    );
    if (benefitsItems && benefitsItems.length) {
      benefitsItems.forEach((benefitsItem, index) => {
        if (index < 3) {
          benefitsContainer.appendChild(benefitsItem);
        }
      });
      benefitsContainer.parentNode.style.display = 'block';
    }
  },

  setVideoControlsHadle() {
    let pauseNode = this.mainProductItem.el.querySelector(
      `.${this.type}__image--pause-play`,
    );
    if (!pauseNode) return;
    let videoControls = this.mainProductItem.el.querySelectorAll(
      `.${this.type}__image--pause-play a`,
    );
    videoControls.forEach((videoControl) => {
      videoControl.addEventListener('click', (e) => {
        e.preventDefault();
        let videoContainer = e.currentTarget.parentNode.parentNode;
        let buttonContainer = e.currentTarget.parentNode;
        let video = videoContainer.querySelector('video')
          ? videoContainer.querySelector('video')
          : new Vimeo.Player(videoContainer.querySelector('iframe'));
        if (e.currentTarget.classList.contains('pause-video')) {
          video.pause();
          buttonContainer.classList.remove('pause');
          buttonContainer.classList.add('play');
        } else {
          video.play();
          buttonContainer.classList.remove('play');
          buttonContainer.classList.add('pause');
        }
      });
    });
  },

  initCarousel(el) {
    if (!el || window.innerWidth > 992) return;

    let html = el.innerHTML;
    let swiperHtml = `<div class='swiper-wrapper'>${html}</div><div class='swiper-pagination'></div>`;
    el.innerHTML = swiperHtml;
    let slides = el.querySelectorAll(`.${this.type}__image--item`);
    slides.forEach((slide) => {
      let slideHtml = slide.outerHTML;
      let swiperSlideHtml = `<div class='swiper-slide'>${slideHtml}</div>`;
      slide.outerHTML = swiperSlideHtml;
    });
    const swiper = new Swiper(el, {
      loop: false,
      slidesPerView: 1.1,
      spaceBetween: 5,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });
    return swiper;
  },

  closeProductAccordions() {
    let accordion = document.querySelectorAll('.product-details__acc');
    accordion.forEach((detail, closeDetail, details) => {
      detail.ontoggle = (closeDetail) => {
        if (detail.open) {
          details.forEach((detailSingle) => {
            if (detailSingle != detail) {
              detailSingle.open = false;
            }
          });
        }
      };
    });
  },

  stickyBuyButton() {
    let buyButtonWrap = document.querySelector(`.${this.type}__form--wrap`),
      initialButtonPosition;
    let scrollBefore = 0;
    let productBody = document.querySelector('.template-product');
    let hideKey;
    if (window.innerWidth > 992) {
      hideKey = 'top';
    } else {
      hideKey = 'bottom';
    }
    document.addEventListener('scroll', function () {
      if (buyButtonWrap.offsetTop > 90) {
        initialButtonPosition = buyButtonWrap.offsetTop;
      }
      const topOfScreen = window.scrollY;
      if (
        topOfScreen > initialButtonPosition &&
        !buyButtonWrap.classList.contains('sticky-add')
      ) {
        buyButtonWrap.style[hideKey] = '-100%';
        productBody.classList.remove('header-active');
      }
      if (
        topOfScreen < initialButtonPosition &&
        !buyButtonWrap.classList.contains('sticky-add')
      ) {
        buyButtonWrap.style[hideKey] = '0%';
      }
      if (
        topOfScreen > initialButtonPosition &&
        !buyButtonWrap.classList.contains('sticky-add')
      ) {
        buyButtonWrap.classList.add('sticky-add');
        buyButtonWrap.style[hideKey] = '0%';
      }
      if (topOfScreen == 0 && buyButtonWrap.classList.contains('sticky-add')) {
        buyButtonWrap.classList.remove('sticky-add');
        buyButtonWrap.style[hideKey] = '0%';
      }
      if (
        buyButtonWrap.classList.contains('sticky-add') &&
        window.innerWidth > 992
      ) {
        if (
          scrollBefore < 2 &&
          !productBody?.classList?.contains('header-active')
        ) {
          scrollBefore = topOfScreen;
          productBody.classList.add('header-active');
          //Desired action
        } else if (
          scrollBefore < topOfScreen &&
          productBody.classList.contains('header-active')
        ) {
          scrollBefore = topOfScreen;
          productBody.classList.remove('header-active');
          //Desired action
        }
      }
      scrollBefore = topOfScreen;
    });
  },

  reviewClickHandle: function () {
    waitForElm('.main-kit-product__reviews .bv_main_container').then(() => {
      let reviewContainers = this.container.querySelectorAll(
        '.main-kit-product__reviews .bv_main_container',
      );
      if (reviewContainers) {
        reviewContainers.forEach((reviewContainer) => {
          reviewContainer.addEventListener('click', (e) => {
            e.preventDefault();
            window.scroll({
              top:
                document
                  .getElementById('BVRRSearchContainer')
                  .getBoundingClientRect().top - 130,
              behavior: 'smooth',
            });
          });
        });
      }
    });
  },

  initMain: function () {
    const mainProduct = this.container.querySelector('[data-main-kit-product]');
    this.mainProductItem = new ProductVariants(mainProduct);
    this.kitProducts = this.container.querySelectorAll('[data-kit-container]');
    if (this.kitProducts.length) {
      let addKitButton = document.querySelector('[data-product-add-kit]');
      this.setBenefits();
      this.setVideoControlsHadle();
      this.kitProducts.forEach((kitProduct) => {
        let kitProductItem = new ProductKit(kitProduct);
        let kitProductWait = setInterval(() => {
          let timespend = timespend + 2;
          if (kitProductItem.allProductStyles != undefined) {
            clearInterval(kitProductWait);
            let kitContainer = document.querySelector(
              `[data-kit-container="${kitProductItem.data.id}"]`,
            );
            let kitVariantsList = kitContainer.querySelector(
              `[data-color-swatches]`,
            );
            let currentItemId = kitProductItem.data.id;

            for (const product in kitProductItem.allProductStyles.products) {
              let swatchProduct =
                kitProductItem.allProductStyles.products[product];
              this.reviewClickHandle();
              let swatchItem = kitProductItem.buildSwatchItem(swatchProduct);
              if (swatchItem) {
                let currentItem =
                  currentItemId == swatchProduct.id ? true : false;
                if (currentItem) {
                  swatchItem.classList.add('selected');
                  if (!swatchProduct.available) {
                    addKitButton.removeAttribute('data-product-add-kit');
                    addKitButton.removeAttribute('data-drawer-trigger');
                    addKitButton.textContent = 'Not Available';
                  }
                  kitVariantsList.prepend(swatchItem);
                  kitProductItem.buildOtherSwatches(
                    swatchProduct,
                    this.type,
                    kitContainer,
                  );
                  kitProductItem.buildKitItemSelected(
                    swatchProduct,
                    this.type,
                    kitContainer,
                  );
                  let sizeGuideToggle =
                    kitProduct.querySelector('.size-guide-toggle');
                  if (sizeGuideToggle) {
                    buildTable(swatchProduct, kitContainer);
                    buildSizes(swatchProduct, swatchProduct.id, 'kit');
                  }
                } else {
                  kitVariantsList.appendChild(swatchItem);
                }
                swatchItem.addEventListener(
                  'mouseenter',
                  () => {
                    if (swatchItem.classList.contains('selected')) {
                      return false;
                    }
                    swatchItem.parentNode.parentNode.querySelector(
                      '[data-product-selected]',
                    ).textContent = swatchItem.dataset.colorName;
                  },
                  false,
                );
                swatchItem.addEventListener(
                  'mouseleave',
                  () => {
                    if (swatchItem.classList.contains('selected')) {
                      return false;
                    }
                    swatchItem.parentNode.parentNode.querySelector(
                      '[data-product-selected]',
                    ).textContent = swatchItem.parentNode.parentNode.querySelector(
                      '.selected[data-product-swatch]',
                    ).dataset.colorName;
                  },
                  false,
                );
                swatchItem.addEventListener('click', (e) => {
                  e.preventDefault();
                  if (e.currentTarget.classList.contains('selected')) {
                    return false;
                  }
                  mainProduct.querySelector(
                    '.main-kit-product__back-in-stock',
                  ).style.display = 'none';
                  kitProductItem.buildOtherSwatches(
                    swatchProduct,
                    this.type,
                    kitContainer,
                  );
                  kitProductItem.buildKitItemSelected(
                    swatchProduct,
                    this.type,
                    kitContainer,
                  );
                  kitVariantsList
                    .querySelector('.selected[data-product-swatch]')
                    .classList.remove('selected');
                  e.currentTarget.classList.add('selected');
                });
              }
            }
            let renderedBadge = this.mainProductItem.buildBadge(
              this.mainProductItem.badgeTags,
            );
            renderedBadge
              ? this.mainProductItem.el
                  .querySelector(`.main-kit-product__image--wrap`)
                  .appendChild(renderedBadge)
              : null;
          } else {
            if (timespend > 5000) {
              clearInterval(kitProductWait);
            }
          }
        }, 2);
      });
    }

    this.mainProductItem.initZoom(this.type);
    this.mainProductItem.BISInit(this.type);
  },

  onLoad: function (e) {
    this.closeProductAccordions();
    this.initedCarousel = this.initCarousel(
      document.querySelector(`.${this.type}__image`),
    );
    this.initMain();
  },
});
